'use client';

import { motion } from 'framer-motion';

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export function ProgressIndicator({ currentStep, totalSteps }: ProgressIndicatorProps) {
  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="w-full px-6 pt-6">
      <div className="max-w-lg mx-auto">
        <div className="flex items-center justify-between mb-2">
          <img src="/images/kinetic.svg" alt="Kinetic" className="h-6" />
          <span className="text-sm text-foreground/50">
            {currentStep + 1} of {totalSteps}
          </span>
        </div>
        <div className="h-1.5 bg-kinetic-pink/30 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-primary rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          />
        </div>
      </div>
    </div>
  );
}
